import { render, staticRenderFns } from "./UiContentFrame.vue?vue&type=template&id=198ee3ab"
import script from "./UiContentFrame.vue?vue&type=script&lang=js"
export * from "./UiContentFrame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports